module.exports = __webpack_public_path__ + "media/images/parallax/illustration-welcome-background-4491bb8fd59ece1ec84b4bc483986f63.svg";